import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

interface FloorPlanNameModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
  defaultName?: string;
  title?: string;
  description?: string;
}

export function FloorPlanNameModal({
  isOpen,
  onClose,
  onSubmit,
  defaultName = '',
  title = 'Name Your Floor Plan',
  description = 'Enter a descriptive name for this floor plan.'
}: FloorPlanNameModalProps) {
  const [name, setName] = React.useState(defaultName);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    setName(defaultName);
    setError('');
  }, [defaultName, isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const trimmedName = name.trim();
    if (!trimmedName) {
      setError('Please enter a name for the floor plan');
      return;
    }

    onSubmit(trimmedName);
    setName('');
    setError('');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="floor-plan-name">Floor Plan Name</Label>
            <Input
              id="floor-plan-name"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                if (error) setError('');
              }}
              placeholder="e.g., Main Floor, Second Floor"
              className={error ? 'border-red-500' : ''}
              autoFocus
            />
            {error && (
              <p className="text-sm text-red-500">{error}</p>
            )}
          </div>
          <div className="flex justify-end gap-3">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit">
              Continue
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
} 